import { action } from "typesafe-actions";
import {
  ICompanyInformation,
  initialAccountingCompanyInformation,
} from "./companyInformation.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { LoadState } from "../../../constants/enums";
import { uploadFile } from "../../../features/FileUpload/utils";

export const FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS";
export const FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS";
export const FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE =
  "FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE";

export const fetchAccountingCompanyInformationProgress = () =>
  action(FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS);
export const fetchAccountingCompanyInformationSuccess = (
  data: ICompanyInformation
) => action(FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS, { data });
export const fetchAccountingCompanyInformationFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE, { errorMessage });

export const fetchAccountingCompanyInformationAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const isSaved = getState().accounting.accountingCompanyInformation.loading === LoadState.Loaded
      if(!isSaved){
        dispatch(fetchAccountingCompanyInformationProgress());

      const res = await api.get(
        `/accounting/get-account-company-information`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingCompanyInformationSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingCompanyInformationSuccess(
            initialAccountingCompanyInformation["data"]
          )
        );
      }
      }
    } catch (err: any) {
      dispatch(
        fetchAccountingCompanyInformationFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingCompanyInformationAysnc =
  (
    data: ICompanyInformation,
    logo: any | null,
    favIcon: any | null,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        company_name: data.company_name,
      };
      const path1 = await uploadFile(
        logo,
        "COMPANY",
        data.logo || "",
        asPayload
      );
      const path2 = await uploadFile(
        favIcon,
        "COMPANY",
        data.fav_icon || "",
        asPayload
      );
      await api.post("/accounting/edit-account-company-information", {
        ...data,
        logo: path1,
        fav_icon: path2
      });

      const message = "Company Information saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true)
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };


export const CLEAR_ACCOUNTING_COMPANY_INFORMATION = "CLEAR_ACCOUNTING_COMPANY_INFORMATION";
export const clearAccountingCompanyInformation = () => action(CLEAR_ACCOUNTING_COMPANY_INFORMATION);